/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2022
 * @flow
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import classes from './StockStatusConfPopup.module.css';

const OUTSTOCK = 'This will update the item to out of stock. Do you want to continue?';
const INSTOCK = 'This will update the item to back in stock. Do you want to continue?';
const OPTIONALMSG = 'Optionally, you can specify a date when item will be back in stock.';

const StockStatusConfirmationPopup = ({ stocked, onCancel, onProceed }) => {
  const [dateTime, setDateTime] = useState('');

  const onChangeDateTime = event => {
    const val = event.target.value;
    setDateTime(val);
  };

  const onSubmit = () => {
    onProceed && onProceed(dateTime);
  };

  return (
    <div className={classes.container}>
      <div className={classes.headingWrapper}>
        <span className={classes.title}>Update Stock Status</span>
      </div>
      <div className={classes.contentWrapper}>
        <div className={classes.msg}>
          {stocked ? OUTSTOCK : INSTOCK}
        </div>
        {stocked && (
          <div className={classes.inputWrapper}>
            <div className={classes.optionalMsg}>
              {OPTIONALMSG}
            </div>
            <div className={classes.inputs}>
              <span className={classes.backInDateTxt}>Back in stock date:</span>
              <input
                type='datetime-local'
                className={classes.dateTimeInput}
                value={dateTime}
                onChange={onChangeDateTime}
              />
            </div>
          </div>
        )}
      </div>
      <div className={classes.buttonsWrapper}>
        <Button className={classes.button} onClick={onCancel}>Cancel</Button>
        <Button className={classes.button} onClick={onSubmit}>Proceed</Button>
      </div>
    </div>
  );
};

export default StockStatusConfirmationPopup;

StockStatusConfirmationPopup.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
};

StockStatusConfirmationPopup.defaultProps = {
  onCancel: () => { },
  onProceed: () => { },
};
